module.exports = __webpack_public_path__ + "img/knoflooksaus-ingredienten.d78e276c.jpeg";